import { Error } from 'services/openapi';

export default function isApiError(obj: any): obj is Error {
  return obj instanceof Object && 'code' in obj && 'description' in obj;
}
